import axios from "axios";

export default function createAxios() {
    return axios.create({
        baseURL: 'https://iustockapi.onerhino.com',
        timeout: 5000,
    })
}
